import {
  colorOrToken,
  Stack,
  Switch,
  tokens,
  Typography,
} from '@cast/design-system';

import { useCommitmentsViewMode } from '../../../_hooks/useCommitmentsViewMode';
import { useUploadCommitmentsContext } from '../UploadCommitmentsProvider';
export const ManageAutoCommitments = () => {
  const { provider, autoEnable, setAutoEnable } = useUploadCommitmentsContext();
  const commitmentsViewMode = useCommitmentsViewMode();

  if (!provider) {
    return null;
  }

  return (
    // No suitable semantic token found: blue.100 border has no exact semantic match (theme.border.status.infoSubtle resolves to blue.200, which is visibly darker).
    // No suitable semantic token found: theme.fg.structural.secondary resolves to grey.500, not grey.600.
    <Stack
      direction="row"
      gap={8}
      mt={8}
      alignItems="flex-start"
      bgcolor={colorOrToken('blue.50', tokens.theme.bg.status.infoSubtle)}
      border={`1px solid ${colorOrToken(
        'blue.100',
        tokens.primitives.colors.blue[100]
      )}`}
      borderRadius="4px"
      py={12}
      px={16}
    >
      <Switch
        checked={autoEnable}
        onChange={() => setAutoEnable(!autoEnable)}
        size="sm"
        testId="commitment-auto-assignment-switch"
      />
      <Typography variant="P12R"></Typography>
      <Stack gap={4}>
        <Typography component="span" variant="A2">
          {commitmentsViewMode.type === 'child-org'
            ? 'Enable commitments and auto-assign to all clusters in all organizations'
            : 'Enable commitments and auto-assign to all clusters'}
        </Typography>
        <Typography
          component="span"
          variant="P12R"
          color={colorOrToken('grey.600', tokens.primitives.colors.grey[600])}
        >
          Eligible clusters will start using commitments for autoscaling.
        </Typography>
      </Stack>
    </Stack>
  );
};
